
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["extractHighlightNotation"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5a23112ca5533e464ee3.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			